/**
 * For Projects to be displayed
 * Image/ background on top, more info on bottom when hovered
 */

import React from 'react';
import { Card, CardMedia, CardContent, Typography, Avatar, CardActionArea } from '@mui/material';
import { styled } from '@mui/system';

const StyledCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  width:"300px",
  height: '300px', // Adjust height as needed  
  '&:hover .an_overlay': {
    opacity: 1,
  },
 
}));

const StyledCardMedia = styled(CardMedia)({
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
});

const Overlay = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  color: '#fff',
  padding: theme.spacing(2),
  opacity: 0,
  transition: 'opacity 0.3s ease',
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(4),
  height: theme.spacing(4),
  marginRight: theme.spacing(1),
}));




function ProjectCard({ project, onClick }) {
  return (
    
    <StyledCard>
        
        
        <StyledCardMedia
            image={project.image_path} // Specify the image URL here
            title={project.title}
            onClick={onClick}
            sx={{cursor:"pointer"}}
        />
        
        <Overlay className='an_overlay'
        sx={{pointerEvents:"none"}}
        >
            <Typography variant="h6" gutterBottom>
            {project.title}
            </Typography>
            <Typography variant="body2" component="p">
            {project.desc}
            </Typography>
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <StyledAvatar src={project.author_avatar_url} alt={project.author} />
            <Typography variant="body2" component="p">
                By {project.author}
            </Typography>
            </div>
        </Overlay>
        
      
    </StyledCard>
    
  );
}

export default ProjectCard;
